export default {
  methods: {
    loadDataOk(result) {
      this.$emit('loadDataOk', result)
    },

    /**
     * @name getControlInfo
     * @param controlInfos
     * @returns {*}
     * @description 获取表单控件属性
     */
    getControlInfo(controlInfos) {
      this.$emit('editControlInfos', controlInfos)
      return controlInfos
    },

    /**
     * @name rowSelectionSelect
     * @param record
     * @param selectedRowKeys
     * @param selectedRows
     * @description
     */
    rowSelectionSelect(record, selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.$emit('rowSelectionSelect', record, selectedRowKeys, selectedRows)
    },
  }
}
